var map = {
	"./ap.svg": 55269,
	"./ca.svg": 37918,
	"./cha.svg": 94468,
	"./cl.svg": 72731,
	"./cli.svg": 36504,
	"./con.svg": 62254,
	"./do.svg": 73921,
	"./ds.svg": 40229,
	"./ma.svg": 47336,
	"./mat.svg": 11188,
	"./me.svg": 71956,
	"./mo.svg": 70206,
	"./ot.svg": 13439,
	"./pe.svg": 50279,
	"./pl.svg": 83966,
	"./pr.svg": 66424,
	"./sg.svg": 55840,
	"./sub.svg": 65020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66618;